export const HIT_SET = 'HIT_SET';
export const HIT_UNSET = 'HIT_UNSET';

